<template>
<!--预录报关 -->
  <div class="page-container" id="ebOrderContainer">
    <el-form :model="searchData" ref="ruleFormRef" class="form-panel" label-position="top"
             :validateOnRuleChange="false">
    <el-col :span="24">
      <el-row class="content-panel pre-recorded-customs-query" id="search">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-col>
                <el-form-item label="经营单位:">
                  <el-input size="mini"
                            placeholder=""
                            clearable
                            v-model="searchData.tradeName">
                  </el-input>

                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="6">
              <el-col>
                <el-form-item label="提单号:">
                  <el-input size="mini"
                            placeholder=""
                            clearable
                            v-model="searchData.mblNo">
                  </el-input>

                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="6">
              <el-col>
                <el-form-item label="客户编号:">
                  <el-input size="mini"
                            placeholder=""
                            clearable
                            v-model="searchData.custBizNo">
                  </el-input>

                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="6" style="padding: 0px">
              <el-col>
                <el-form-item label="订单号:">
                  <el-input size="mini"
                            placeholder=""
                            clearable
                            v-model="searchData.orderNo">
                  </el-input>

                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="6">
              <el-col>
                <el-form-item label="海关条码:">
                  <el-input size="mini"
                            placeholder=""
                            clearable
                            v-model="searchData.preEntryId">
                  </el-input>

                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="6">
              <el-col>
                <el-form-item label="船名:">
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_vessel"
                    :query-method="associate_queryMethod_vessel"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="vesselName"
                    value-prop="vesselId"
                    placeholder=""
                    v-model="searchData.vesselId"
                    size="mini"
                    name="vesselName"
                    @change="onChangeVessel"
                    case="upper"
                  />

                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="6">
              <el-col>
                <el-form-item label="航次:">
                  <el-input size="mini"
                            placeholder=""
                            clearable
                            v-model="searchData.voyage">
                  </el-input>

                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="开航日期从:">
                    <el-date-picker
                      v-model="searchData.etds"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="开航日期到:">
                    <el-date-picker
                      v-model="searchData.etde"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="3" class="advanced-query-btns">
            <el-button class="el-button-search" type="primary" size="small" plain @click="queryForm" >查询</el-button>
            <el-button type="primary" size="small" plain @click="resetForm" >重置</el-button>
            </el-col>
          </el-row>
      </el-row>
        <!-- </div> -->
    <el-row class="pre-recorded-customs-tab">
          <el-row :gutter="10">
            <el-col :span="18" style="margin:10px">
              <el-button class="el-button-search" type="primary" size="small" plain @click="openPrint">打印</el-button>
            </el-col>
          </el-row>
        <!-- 表格-start -->
        <el-row class="pre-recorded-customs-table">
          <hot-table ref="ebOrderTableRef" :data-source="PreRecordedCustomsDataSource"
                     :settings="PreRecordedCustomsTableSettings" col-settings-key="shippingDate">
            <hot-column :has-tip="true" data="declareStatus" title="报关单状态" width="150"></hot-column>
            <hot-column :has-tip="true" data="agentName" title="申报单位" width="150"></hot-column>
            <hot-column :has-tip="true" data="tradeName" title="经营单位"  width="150"></hot-column>
            <hot-column :has-tip="true" data="ieFlag" dictName="MD_CODE_DICT$EB_CD_IE_TYPE" title="进出口"  width="150"></hot-column>
            <hot-column :has-tip="true" data="entyPortCn" title="通关模式" width="150"></hot-column>
            <hot-column :has-tip="true" date-format="YYYY-MM-DD" data="declareDate" title="申报日期" width="150"></hot-column>
            <hot-column :has-tip="true" data="preEntryId" title="海关条码" width="150"></hot-column>
            <hot-column :has-tip="true" data="tradeModeName" title="贸易方式" width="150"></hot-column>
            <hot-column :has-tip="true" data="billNo" title="提运单号" width="150"></hot-column>
            <hot-column :has-tip="true" data="contrNo" title="合同编号" width="150"></hot-column>
            <hot-column :has-tip="true" data="cargoName" title="品名" width="150"></hot-column>
            <hot-column :has-tip="true" data="declareRemark" title="备注" width="150"></hot-column>
            <hot-column :has-tip="true" data="orderNo" title="订单号" width="150"></hot-column>
            <hot-column :has-tip="true" data="custBizNo" title="客户编号" width="150"></hot-column>
            <hot-column :has-tip="true" data="mblNo" title="提单号" width="150"></hot-column>
            <hot-column :has-tip="true" data="vesselNameEn" title="船名" width="150"></hot-column>
            <hot-column :has-tip="true" data="voyage" title="航次" width="150"></hot-column>
            <hot-column :has-tip="true" data="etd" title="开航日期"  date-format="YYYY-MM-DD"  width="150"></hot-column>
            <hot-column :has-tip="true" data="placeOfDeliveryName" title="目的港" width="150"></hot-column>
          </hot-table>
        </el-row>
    </el-row>
    </el-col>
        <!-- 分页start -->
        <div class="pg_div">
          <el-pagination :current-page="pageConfig.currentPage" :layout="pageConfig.layout"
                         :page-size="pageConfig.pageSize" :page-sizes="pageConfig.pageSizes" :total="pageConfig.total"
                         @current-change="handleCurrentChange" @size-change="handleSizeChange"/>
        </div>
        <!-- 分页end -->
        <!-- 表格-end -->

    </el-form>
    <el-dialog
      :visible.sync="mdReportTemplateVisible"
      title="打印"
      :append-to-body="true"
      :close-on-click-modal="true"
      width="70%"
    >
      <el-row>
        <el-button class="el-button-search" type="primary" size="small" plain @click="preview()" >预览</el-button>
        <el-button class="el-button-search" type="primary" size="small" plain   >打印</el-button>
      </el-row>
      <el-row style="margin-top: 15px;margin-bottom: 20px;height: 300px">
        <hot-table
          ref="mdReportTemplateTableRef"
          :data-source="mdReportTemplateData"
          col-settings-key="onlineServiceDialogTable"
        >
          <hot-column :has-tip="true" data="templateNameCn" title="套版名称" width="150"></hot-column>
        </hot-table>
        <!-- 分页start -->
        <!-- 分页end -->
      </el-row>
      </el-dialog>
  </div>
</template>

<script>

import { getCdPlanMatchedDetailPaging } from "@/api/cdPlanMatchedDetailApi";
import { queryMdReportTemplate } from "@/api/common";
import {queryVoyageInfo} from "@/api/commonService";

export default {
  name: "PreRecordedCustoms",
  data() {
    return {
      mdReportTemplateVisible: false,
    dict: { },
    searchData: {
      tradeName: null
    },
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
    PreRecordedCustomsDataSource: [],
      mdReportTemplateData: [],
    //日期设置
    pickerOptions: {
      shortcuts: [{
        text: '今天',
        onClick(picker) {
          picker.$emit('pick', new Date());
        }
      }, {
        text: '昨天',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          picker.$emit('pick', date);
        }
      }, {
        text: '一周前',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', date);
        }
      }]
    },
    // 分页
    pageConfig: {
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      pageSize: 100,
      pagerCount: 100,
      currentPage: 1,
      pageSizes: [10, 20, 50, 100]
    },
    PreRecordedCustomsTableSettings: {
      height: 520,
      stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
      ...this.$systemConfig.tableConfig
    },
    }
  },
  async created() {
  },
  activated() {
    setTimeout(() => {
      this.$nextTick (() => {
        this.$refs.ebOrderTableRef.render()
      })
    },100);
  },
  async mounted() {
    //初始化数据字典
    let dictCode = [];
    dictCode.push("MD_CODE_DICT$EB_CD_IE_TYPE");
    this.dict = await this.$getDataDictionary.getSelectList(dictCode.join(','));
    for(var key in this.dict){
      let dict = [];
      this.dict[key].forEach((item) => {
        let param = {};
        param.name = item.value;
        param.value = item.key;
        param.count = 0;
        dict.push(param);
      });
      let dicts = {};
      dicts[key] = dict;
      this.$hotTableUtils.registDict(dicts);
    }
    this.PreRecordedCustomsTableSettings.height = document.body.clientHeight -(300);
  },
  methods: {
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageConfig.currentPage = val;
      let self = this;
      self.queryStatusPage();
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryStatusPage();
    },
    queryForm() {
      let self = this;

      // if(this.searchData.tradeName!==null   &&  this.searchData.tradeName!==undefined   && this.searchData.tradeName!=='' ){
      // }else {
      //   self.$coreMethods.message(
      //     "warning",
      //     "请输入查询条件"1.开航日期（限定日期和范围日期）:mf_order.etd


      var params = {};
      if(this.searchData.tradeName!==null   &&  this.searchData.tradeName!==undefined   && this.searchData.tradeName!==''){
        this.searchData.tradeName = this.searchData.tradeName.replaceAll(" ", "")
        params.tradeName = this.searchData.tradeName+"%";
      }

      if(this.searchData.mblNo!==null   &&  this.searchData.mblNo!==undefined   && this.searchData.mblNo!==''){
        this.searchData.mblNo = this.searchData.mblNo.replaceAll(" ", "")
        params.mblNo = this.searchData.mblNo+"%";
      }

      if(this.searchData.orderNo!==null   &&  this.searchData.orderNo!==undefined   && this.searchData.orderNo!==''){
        this.searchData.orderNo = this.searchData.orderNo.replaceAll(" ", "")
        params.orderNo = this.searchData.orderNo+"%";
      }

      if(this.searchData.custBizNo!==null   &&  this.searchData.custBizNo!==undefined   && this.searchData.custBizNo!==''){
        this.searchData.custBizNo = this.searchData.custBizNo.replaceAll(" ", "")
        params.custBizNo = this.searchData.custBizNo+"%";
      }

      if(this.searchData.voyage!==null   &&  this.searchData.voyage!==undefined   && this.searchData.voyage!==''){
        this.searchData.voyage = this.searchData.voyage.replaceAll(" ", "")
        params.voyage = this.searchData.voyage;
      }
      if(this.searchData.preEntryId!==null   &&  this.searchData.preEntryId!==undefined   && this.searchData.preEntryId!==''){
        this.searchData.preEntryId = this.searchData.preEntryId.replaceAll(" ", "")
        params.preEntryId = this.searchData.preEntryId;
      }

      if(this.searchData.vesselId!==null   &&  this.searchData.vesselId!==undefined   && this.searchData.vesselId!==''){
        params.vesselId = this.searchData.vesselId;
      }

      if(this.searchData.etds!==null   &&  this.searchData.etds!==undefined   && this.searchData.etds!==''){
        params.etds = new Date((new Date(this.searchData.etds)).getTime()+28800000);
      }

      if(this.searchData.etde!==null   &&  this.searchData.etde!==undefined   && this.searchData.etde!==''){
        params.etde = new Date((new Date(this.searchData.etde)).getTime()+28800000);
      }
      if(JSON.parse(localStorage.getItem('userInfo')) && JSON.parse(localStorage.getItem('userInfo')).custId!=null){
        params.custId = JSON.parse(localStorage.getItem('userInfo')).custId;
      }



      let searchData = {
        currentPage: self.pageConfig.currentPage,
        pageSize: self.pageConfig.pageSize,
        queryParams: params,
      };

      getCdPlanMatchedDetailPaging(searchData).then((res) => {
        console.log("queryEbOrder", res);
        if (res.records.length>0) {
          self.PreRecordedCustomsDataSource = res.records;
          self.pageConfig.total = res.totalRecord;
          if (res.totalRecord === 0){
            self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
          }else {
            self.$coreMethods.message("success", "查询成功！");
          }
        }else {
          self.PreRecordedCustomsDataSource = [];
          self.pageConfig.total = 0;
          self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
        }
      });


    },
    resetForm(){
      this.searchData.tradeName = null;
      this.searchData.etds = null;
      this.searchData.etde = null;
      this.searchData.orderNo = null;
      this.searchData.custBizNo = null;
      this.searchData.mblNo = null;
      this.searchData.voyage = null;
      this.searchData.preEntryId = null;
      this.searchData.vesselId = null;
      this.searchData.vesselName = null;
    },
    openPrint(){
      let self = this;
      if(this.$refs.ebOrderTableRef.getSelections().length==1){
        if(this.$refs.ebOrderTableRef.getSelections()[0].brokerMblNo==null){
          this.$coreMethods.message("error", "报关单号不能为空，请检查！");
          return;
        }
        this.reportPrimaryId = this.$refs.ebOrderTableRef.getSelections()[0].goOrderId;
        this.mdReportTemplateVisible= true;
        let searchData = {
          apiKey : "CTS_ILP_MdReportTemplate",
          sqlKey: "CTS_ILP_MdReportTemplate",
          tag: "CTS_ILP_MdReportTemplate",
          reqArgs: {"templateTypeCode": "OLS_CD_PLAN_PRINT"},
          action: "query",
          returnTotal: false
        }
        queryMdReportTemplate(searchData).then((res) => {
          console.log("queryEbOrder", res);
          if (res.success == true ) {
            this.mdReportTemplateData = res.data;
            if (res.data.length === 0){
              this.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            }else {
              this.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }else {
        this.$coreMethods.message("warning", "请勾选一条数据！");
      }
    },
    preview(){
      let self = this;
      if(this.$refs.mdReportTemplateTableRef.getSelections().length==1){

        if(this.$refs.mdReportTemplateTableRef.getSelected().reportUrl==null){
          this.$coreMethods.message("error", "报表路径错误，请检查！");
          return;
        }

        this.mdReportTemplateVisible= false;
        this.$router.push({
          name: "reportShow",
          query: {
            systemType: this.$refs.mdReportTemplateTableRef.getSelected().systemType,
            reportUrl: this.$refs.mdReportTemplateTableRef.getSelected().reportUrl,
            primaryId: this.reportPrimaryId
          }
        });
      }else {
        this.$coreMethods.message("warning", "请勾选一条数据！");
      }
    },
    associate_queryMethod_vessel({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.vesselName"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    onChangeVessel(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.searchData.voyage = selectedRows.voyage;
      this.searchData.vesselId = selectedRows.vesselId;
    }
  }
}
</script>

<style scoped>
 .pre-recorded-customs-query{
    margin: 0;
    border-radius: 10px;
 }
.pre-recorded-customs-tab{
  margin-top: 16px;
  background-color:white;
  border-radius: 10px;
}
.pre-recorded-customs-table{
  width: 100%;
  overflow: hidden;
}
</style>
